import { useCallback, useEffect, useState } from "react";
import Fuse from "fuse.js";
import { FaPlus } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import Card from "../../atoms/Card";
import CardHeader from "../../atoms/CardHeader";
import IconButton from "../../atoms/IconButton";
import Modal from "../../molecules/Modal";
import InmueblesTable from "../../organisms/inmuebles/InmueblesTable";
import InmueblesFilter from "../../organisms/inmuebles/InmueblesFilter";
import InmueblesCreate from "../../organisms/inmuebles/InmueblesCreate";
import { GET_INMUEBLES_ESTATE } from "../../../api/apiInmuebles";
import useModal from "../../../hooks/useModal";
import { getInmobiliaria } from "../../../utils/getInmobiliaria";
import { exportToExcelInmuebles } from "../../../utils/excel/exportToExcelInmuebles";
import Breadcrumb from "../../molecules/Breadcrumb";

const InmueblesTemplate = () => {
    const { id } = useParams();
    const { open, isOpen, close } = useModal();
    const { open: openOrg, isOpen: isOpenOrg, close: closeOrg } = useModal();
    const [inmuebles, setInmuebles] = useState([]);
    const [filteredInmuebles, setFilteredInmuebles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ name: "", address: "", type: "", isRented: "", isMortgaged: "" });

    const getInmuebles = useCallback(async () => {
        try {
            setLoading(true);
            const inmueblesData = await GET_INMUEBLES_ESTATE(id);
            console.log(inmueblesData);
            console.log(id);

            setInmuebles(inmueblesData);
            setFilteredInmuebles(inmueblesData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        getInmuebles();
    }, [getInmuebles]);

    useEffect(() => {
        if (!inmuebles) return;

        let filtered = [...inmuebles];

        if (filters.isRented === "true") {
            filtered = filtered.filter(item => item.isRented === true);
        } else if (filters.isRented === "false") {
            filtered = filtered.filter(item => item.isRented === false);
        }

        if (filters.isMortgaged === "true") {
            filtered = filtered.filter(item => item.isMortgaged === true);
        } else if (filters.isMortgaged === "false") {
            filtered = filtered.filter(item => item.isMortgaged === false);
        }

        if (filters.type) {
            filtered = filtered.filter(item => item.type === filters.type);
        }

        const searchTerms = `${filters.name} ${filters.address}`.trim();
        if (searchTerms) {
            const fuse = new Fuse(filtered, {
                keys: ["name", "address", "type"],
                threshold: 0.3,
            });

            const results = fuse.search(searchTerms).map(result => result.item);
            setFilteredInmuebles(results);
        } else {
            setFilteredInmuebles(filtered);
        }
    }, [filters, inmuebles]);

    return (
        <div className="flex flex-col gap-4">
            <CardHeader
                left={
                    <Breadcrumb
                        items={[
                            { label: "Inmobiliarias", to: "/inmobiliarias" },
                            { label: getInmobiliaria(id), to: `/inmobiliarias/${id}` },
                        ]}
                    />
                }
                right={
                    <div className="flex flex-row gap-2">
                        <IconButton
                            icon={PiMicrosoftExcelLogoFill}
                            bgColor="bg-green-600" iconColor="text-white"
                            onClick={() => exportToExcelInmuebles(filteredInmuebles)}
                        />
                        <IconButton icon={FaPlus} bgColor="bg-green-600" onClick={open} />
                    </div>
                }
            />
            <Card>
                <InmueblesFilter filters={filters} setFilters={setFilters} />
                <InmueblesTable data={filteredInmuebles} loading={loading} refetch={getInmuebles} />
            </Card>
            {isOpen &&
                <Modal heigth="h-[90%]" title={`Agregar inmueble a ${getInmobiliaria(id)}`} onClose={close}>
                    <InmueblesCreate refetch={getInmuebles} onClose={close} />
                </Modal>
            }
            {isOpenOrg &&
                <Modal title={`Organigrama ${getInmobiliaria(id)}`} onClose={closeOrg}>

                </Modal>
            }
        </div>
    );
};

export default InmueblesTemplate;